export * from './alpha.annotation';
export * from './alphaNumeric.annotation';
export * from './compare.annotation';
export * from './contains.annotation';
export * from './email.annotation';
export * from './hexColor.annotation';
export * from './lowercase.annotation';
export * from './maxDate.annotation';
export * from './maxLength.annotation';
export * from './minDate.annotation';
export * from './maxNumber.annotation';
export * from './minNumber.annotation';
export * from './minLength.annotation';
export * from './nested.annotation';
export * from './pattern.annotation';
export * from './required.annotation';
export * from './uppercase.annotation';
export * from './range.annotation';


// WEBPACK FOOTER //
// ./node_modules/@rx/annotations/index.ts